import React from 'react';
import { useNavigate } from 'react-router';
import { Card } from 'antd';

const { Meta } = Card;

const EmployessItem = ({ item }) => {
  const navigate = useNavigate();
  const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;
 
  const imgSrc = item.img?.startsWith("http")
    ? item.img
    : `${imageBaseUrl}/${item.img}`;

  return (
    <div key={item.id} className="flip-card">
      <div className="flip-card-inner">

        <div className="flip-card-front">
          <Card
            cover={
              <img
                className="employee-img"
                alt={item.name}
                src={imgSrc}
              />
            }
          >
            <Meta
              style={{ height: "30px" }}
              title={<span>{item.name}</span>}
              description={item.expertise}
            />
          </Card>
        </div>

        <div className="flip-card-back">
          <div className="employess-info">
            <div className="employess-name">
              <p>{item.name}</p>
            </div>
            <div className="employess-task">
              <p>{item.expertise}</p>
            </div>
            <div
              onClick={() => navigate(`/calisanlar/${item.id}`)}
              className="review-me-btn"
            >
              Beni Değerlendir
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default EmployessItem;
